import { render, staticRenderFns } from "./MessageHome.vue?vue&type=template&id=11c87714&scoped=true&"
import script from "./MessageHome.vue?vue&type=script&lang=js&"
export * from "./MessageHome.vue?vue&type=script&lang=js&"
import style0 from "./MessageHome.vue?vue&type=style&index=0&id=11c87714&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c87714",
  null
  
)

export default component.exports